var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.9,64.4c-0.3-35.7-23.8-59.1-59.5-59.3C178.6,4.9,122,5,65.3,5.2C28.8,5.3,5.3,28.7,5.2,65 C5,121.7,5,178.3,5.2,235c0.1,36.3,23.6,59.7,60.1,59.9c56.3,0.2,112.6,0.2,168.9,0c37.2-0.1,60.5-23.4,60.7-60.4 c0.2-28.1,0-56.3,0-84.4C294.9,121.5,295.1,93,294.9,64.4z M189.9,234.2c-3.1-0.2-6.4-4.6-8.8-7.7c-13.3-17.6-26.3-35.4-40.3-54.3 c-15.3,18.1-30.4,34.8-44,52.5c-7.6,9.9-16.2,11.7-29.5,8.6c21.4-25.4,42-49.8,63.2-75.1C108.1,128,86,97.9,62,65.5 c18.4,0,34.3-0.4,50.1,0.3c2.8,0.1,5.7,4.4,7.9,7.2c11.9,15.9,23.5,32,36.3,49.5c13.9-16.4,27.9-31.5,40.1-47.9 c7.8-10.5,16.7-10.4,29.3-8.4c-16,18.9-30.8,36.6-45.7,54.3c-13.4,15.9-13.5,15.9-1.1,32.8c17,23.3,34.1,46.7,51.1,70 c2.2,3,4.1,6,7.6,11.2C220.3,234.6,205,235.1,189.9,234.2z M119.1,90.9c-8.4-12-17.3-16.4-32.3-12.4c2.7,3.9,4.7,7,6.8,9.9 c30.1,40.7,60.7,81.1,89.9,122.4c8.1,11.4,16.8,12.4,29.6,10.2c-2.9-4.3-5.1-7.7-7.4-10.9C176.8,170.5,147.3,131.2,119.1,90.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.e4016a0c47c5119c039e8394af18c6bb.svg";
export { ForwardRef as ReactComponent };